<template>
  <div class="h-screen flex w-full">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto">
      <vx-card>
        <vs-row class="p-0" slot="no-body">
          <vs-col class="text-center p-0 login-side-image" vs-xs="12" vs-sm="6" vs-lg="6">
          </vs-col>
          <vs-col class="p-base" vs-xs="12" vs-sm="6sm" vs-lg="6">
            <vs-row>
              <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                <img :src="logo" class="login-logo mx-auto" />
              </vs-col>
              <vs-col class="mt-2">
                <h3 class="mt-2">Sign Up</h3>
              </vs-col>

              <vs-col size="12" style="display:flex;">
                <vs-input style="width: 50%; margin-right:10px;"
                          v-model="firstName"
                          type="text"
                          label="First Name*"
                          placeholder="Enter First Name"
                          class="w-half mb-3"
                />
                <vs-input style="width: 50%"
                          v-model="lastName"
                          type="Email"
                          label="Last Name*"
                          placeholder="Enter Last Name"
                          class="w-half mb-3"
                />
              </vs-col>
              <vs-col size="12" class="mb-2">
                <div class="flex items-center">
                  <span class="mr-4 font-semibold">Gender*</span>
                  <label v-for="user in Users" :key="user.name" style="display: flex; margin-right: 18px;">
                    <input type="radio" :value="user.name" v-model="picked" />
                    <span style="padding-left: 4px;">{{ user.name }}</span>
                  </label>
                </div>
              </vs-col>
              <vs-col size="12" style="display:flex;">
                <vs-input style="width: 100%;"
                          v-model="email"
                          type="Email"
                          label="Email*"
                          placeholder="Enter Email Address"
                          class="mb-2"
                />
              </vs-col>
              <vs-col size="12" style="display:flex;">
                <vs-input style="width: 100%"
                          v-model="password"
                          type="password"
                          label="Password*"
                          placeholder="Enter Password"
                          class="w-half mb-2"
                />
              </vs-col>
              <vs-col size="12" style="display:flex;">
                <vs-input style="width: 100%;"
                          v-model="mobileNumber"
                          type="number"
                          label="Mobile Number*"
                          placeholder="Enter Mobile Number"
                          class="w-half mb-3"
                />
              </vs-col>
              <vs-col class="mt-3">
                <vs-button :disabled="!isValidForm" @click.prevent="submit" style="width: 140px">Submit</vs-button>
              </vs-col>

              <vs-col class="mt-8">
                <hr style="background: #eee; margin-bottom: 15px;">
                <medium style="display: block;">
                  Already have an account? <router-link :to="{name: 'page-sign-in'}">
                  Sign in
                </router-link>
                </medium>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vx-card>
      <div class="text-center mt-3">
        <small>v{{ $store.state.version }}</small>
      </div>
    </div>
  </div>
</template>
<script>
import { Request } from '../../utils/requests'
export default {
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      mobileNumber: '',
      picked: 'Male',
      Users: [{ name: 'Male' }, { name: 'Female' }, { name: 'Others' }],
      submit_disabled: false,
      api_errors: {}
    }
  },
  computed: {
    logo () {
      return require('@/assets/images/logo/logo.png')
    },
    isValidEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailPattern.test(this.email)
    },
    isValidMobileNumber() {
      const mobilePattern = /^\d{10}$/
      return mobilePattern.test(this.mobileNumber)
    },
    isValidForm() {
      return this.firstName && this.lastName && this.isValidEmail && this.password && this.isValidMobileNumber && this.picked
    }
  },
  methods: {
    submit () {
      this.submit_disabled = true
      const payload = {
        first_name: this.firstName,
        last_name: this.lastName,
        gender: this.picked.toLowerCase(),
        email: this.email,
        mobile_number: this.mobileNumber,
        password: this.password
      }
      Request(this, 'POST', this.$store.state.apiendpoints.sign_up, null, payload, {}, false).then(
        res => {
          if(res.message==="User created successfully."){
            this.$vs.notify({
              time: 2500,
              title: 'Success',
              text: 'User created successfully.',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color:'success'
            })
            this.$router.push({ name: 'page-login' })
          }
        },
        err => {
          this.submit_disabled = false
          if (err.error) {
            this.api_errors = err.error.message || err.error.password || err.error.email
            this.$vs.notify({
              time: 2500,
              title: 'Login Failed',
              text: this.api_errors,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            this.$vs.notify({
              time: 2500,
              title: 'API Error',
              text: 'An Error Occurred. Please try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
    }
  }
}
</script>
<style lang="scss">
.login-logo {
  max-height: 50px;
  margin-bottom: 30px;
}
.login-side-image {
  background-image: url('../../assets/images/pages/21.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 1.5rem 0 0 1.5rem;
}
.vs-radio-group {
  display: flex;
  align-items: center;
}
.vs-radio {
  margin-right: 10px;
}
@media only screen and (max-width: 600px) {
    .vs-xs-12 {
        width: 100% !important;
    }
    .vs-col{
      padding: 0;
    }
}
</style>
